import { Wave } from '../../wave/types/wave.type';
import { StripSquare } from './StripSquare';
import { getOptionalTagLabel } from '../../wave/utils/tags.utils';
import { squareToPixel, TEXT_HEIGHT } from '../utils/graph.utils';
import { useStrip } from '../hooks/useStrip';

interface Props {
  wave: Wave;
}

export const WaveNoiseOptionalTag = ({ wave }: Props) => {
  const { xScale, onset } = useStrip();
  const xOffset = xScale((wave.offset - wave.onset) / 2 + onset);
  const textOffset = -squareToPixel(2 / 3);
  const label = getOptionalTagLabel(wave);

  if (label === '') {
    return null;
  }
  return (
    <StripSquare onset={wave.onset} offset={wave.offset}>
      <g
        style={{
          transform: `translate(${xOffset}px, 100%)`,
          fontSize: TEXT_HEIGHT,
        }}
      >
        <text>|</text>
        <text
          style={{
            transform: `translate(0px, ${textOffset}px)`,
          }}
        >
          {label.toUpperCase()}
        </text>
      </g>
    </StripSquare>
  );
};
